import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { CHARACTER_DIRECTION } from "common/model";

// CHARACTER_DIRECTION → world forward
// character mesh は scaling.z = -1.2（鏡像反転）のため、rotation.y で示される向きと
// 見た目の forward は逆向きになる。よってキャラの「見た目の前方」は世界座標で反転する：
// _X(rot=π/2)→見た目-X、_MINUS_X(rot=-π/2)→見た目+X、_Z(rot=0)→見た目-Z、_MINUS_Z(rot=π)→見た目+Z
export const FORWARD_WORLD: Record<CHARACTER_DIRECTION, { dx: number; dz: number }> = {
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_X]: { dx: -1, dz: 0 },
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X]: { dx: 1, dz: 0 },
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z]: { dx: 0, dz: -1 },
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z]: { dx: 0, dz: 1 },
};

// rotation.y -= π/2（performTurnToLeft 同等）の結果に揃える
export const TURN_LEFT: Record<CHARACTER_DIRECTION, CHARACTER_DIRECTION> = {
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_X]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X]:
    CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_X,
};

export const TURN_RIGHT: Record<CHARACTER_DIRECTION, CHARACTER_DIRECTION> = {
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_X]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z]:
    CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z]: CHARACTER_DIRECTION.CHARACTER_DIRECTION_X,
};

export const ROTATION_Y: Record<CHARACTER_DIRECTION, number> = {
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_X]: Math.PI / 2,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X]: -Math.PI / 2,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_Z]: 0,
  [CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_Z]: Math.PI,
};

export type GameState = {
  charMesh: AbstractMesh | null;
  charDir: CHARACTER_DIRECTION;
  startWorldPos: Vector3;
  startCharDir: CHARACTER_DIRECTION;
  isAnimating: boolean;
  totalBoxCount: number;
};
